module.exports = __webpack_public_path__ + "img/img74.16c3c607.svg";